import Tasks from 'APP/Tasks';
import { getFriendsNotInvitedToGroup as apiGetFriendsNotInvitedToGroup } from 'APP/model/group/groupModel';
import { IGetFriendsNotInvitedToGroupRequest } from 'APP/model/group/groupModel.types';
import { Features } from 'APP/packages/features/Features';
import Entities from 'STORE';

async function request(data: IGetFriendsNotInvitedToGroupRequest): Promise<string[]> {
  try {
    const response = await apiGetFriendsNotInvitedToGroup(data);

    return response.usersDisplayData.map((user) => user.id);
  } catch (error) {
    return [];
  }

  return [];
}

interface IGetFriendsNotInvitedToGroupParams {
  groupId: string;
}

export async function getFriendsNotInvitedToGroup(
  data: IGetFriendsNotInvitedToGroupParams
): Promise<string[]> {
  let usersIds: string[] = [];
  if (Features.isContactsEnabled()) {
    usersIds = await request(data);

    await Tasks.relationships.loadUnknownUsersByIds({
      usersIds,
    });
  } else {
    usersIds = Entities.usersStore.userContacts.map((contact) => contact.id);
  }

  return usersIds;
}
